<div class="footer">
  <div class="footer__links">
    <span>{{'components.footerComponent.version' | translate}}: <b>{{version}}</b></span>
  </div>
  <div class="footer__copyrights">
    <label>{{'components.footerComponent.copyright' | translate}}</label>
  </div>
  <div class="footer__env">
    <label>{{envName | async}}</label>
  </div>
</div>
